/**
 * Updates multiple nodes with their complete details from the API
 * @param {Object} nodesDataMap - Map of nodeID -> node complete data
 * @param {Array} initNodesState - Current nodes state
 * @returns {Array} - Updated nodes array
 */
export const updateFlowNodesCompleteDetails = (nodesDataMap, initNodesState) => (
  initNodesState.map(node => {
    const nodeCompleteData = nodesDataMap[node.id];

    // If this node has updated data, merge it
    if (nodeCompleteData) {
      return {
        ...node,
        data: {
          ...node.data,
          ...nodeCompleteData,
          // Preserve existing level if not provided in new data
          level: nodeCompleteData.level ?? node.data.level,
        },
      };
    }

    // Otherwise return the node unchanged
    return node;
  })
);

